"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _SelectBox = _interopRequireDefault(require("./styles/SelectBox"));
var _shared = _interopRequireDefault(require("./styles/shared"));
var _excluded = ["containerClassName", "className", "text", "options", "children", "disabled"];
/* eslint jsx-a11y/no-onchange: "off" */
var SelectBox = function SelectBox(_ref) {
  var containerClassName = _ref.containerClassName,
    className = _ref.className,
    text = _ref.text,
    options = _ref.options,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var hasChildren = !!children;
  var hasOptions = !!options;
  var isFn = typeof children === 'function';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('has-float-label', 'select-container', _shared["default"].controlContainer, containerClassName)
  }, /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({
    className: (0, _classnames["default"])('select-box', _SelectBox["default"].select, className),
    disabled: disabled
  }, props), hasChildren && !isFn && children, hasChildren && isFn && hasOptions && options.map(children), !hasChildren && hasOptions && options.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: item.value,
      value: item.value
    }, item.text);
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: props.id
  }, text));
};
SelectBox.displayName = 'SelectBox';
var _default = exports["default"] = SelectBox;